<script setup lang="ts">

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" style="display:none;">
    <slot/>
  </svg>
</template>
